// extracted by mini-css-extract-plugin
export default {"button":"gosuslugibutton_button__3XYhT"};